package org.hs_soft.runmynesto.pages.components

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.foundation.layout.Spacer
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.width
import com.varabyte.kobweb.compose.ui.thenIf
import org.hs_soft.runmynesto.domain.config.Dimen
import org.hs_soft.runmynesto.domain.model.home.template.GridItemsFilterEnum
import org.hs_soft.runmynesto.domain.util.Res

import org.hs_soft.runmynesto.domain.util.helper.Strings
import org.jetbrains.compose.web.css.CSSSizeValue
import org.jetbrains.compose.web.css.CSSUnitLength


@Composable
fun FilterRow(
    modifier: Modifier = Modifier,
    fillMaxWidth: Boolean = false,
    selectedFilterType: GridItemsFilterEnum,
    width: CSSSizeValue<out CSSUnitLength> = Dimen.gridWidth,
    onAddRecordClick: () -> Unit,
    onFilterClick: () -> Unit,
)
{
    Row(
        modifier = modifier
            .width(width)
            .thenIf(
                fillMaxWidth,
                Modifier.fillMaxWidth()
            )
        ,
        verticalAlignment = Alignment.CenterVertically
    )
    {
        FilterComponent(
            title = Strings.current().filter,
            selectedFilterType=selectedFilterType,
            onFilterClick={
                onFilterClick()
            }
        )

        Spacer()

        CustomIcon(
            icon = Res.PathIcon.add,
            onIconClick = {
                onAddRecordClick()
            },
            tooltipText = Strings.current().add
        )


    }
}

